import { put } from './requests'

export function updateBranding (branding) {
  return put('branding', branding)
}
